// Per-Route OG-/Twitter-Bilder. URLs sind absolut auf SITE_ORIGIN,
// damit Social-Crawler sie zuverlässig laden. Dateien liegen in /public/og/.
import type { Lang } from "./seo";

// Absolut, damit Crawler die Bilder unabhängig vom aktuellen Host laden.
// Hardcodiert, um einen Zirkelbezug mit seo.ts (SITE_ORIGIN) zu vermeiden,
// bei dem SITE_ORIGIN bei Modul-Init noch undefined wäre.
const OG_ORIGIN = "https://retatrutide-thailand.org";

interface OgImage {
  url: string;
  alt: Record<Lang, string>;
}

const img = (file: string) => `${OG_ORIGIN}/og/${file}`;

export const ogImages: Record<string, OgImage> = {
  "/": {
    url: img("home.jpg"),
    alt: {
      de: "Retatrutid Thailand – ärztlich begleitete Behandlung in Bangkok",
      en: "Retatrutid Thailand – medically supervised treatment in Bangkok",
    },
  },
  "/wissenschaft": {
    url: img("wissenschaft.jpg"),
    alt: {
      de: "Retatrutid Wirkmechanismus – GLP-1-, GIP- und Glucagon-Rezeptoren",
      en: "Retatrutide mechanism of action – GLP-1, GIP and glucagon receptors",
    },
  },
  "/studien": {
    url: img("studien.jpg"),
    alt: {
      de: "TRIUMPH Phase-III-Studien zu Retatrutid im Labor",
      en: "TRIUMPH Phase III clinical studies on Retatrutide in the lab",
    },
  },
  "/rechner": {
    url: img("rechner.jpg"),
    alt: {
      de: "Gewichtsverlust-Rechner Retatrutid, Tirzepatid und Semaglutid",
      en: "Weight-loss calculator Retatrutide, Tirzepatide and Semaglutide",
    },
  },
  "/sicherheit": {
    url: img("sicherheit.jpg"),
    alt: {
      de: "Retatrutid Sicherheit – Ampulle und Warnhinweise",
      en: "Retatrutide safety – vial and warnings",
    },
  },
  "/faq": {
    url: img("faq.jpg"),
    alt: {
      de: "Retatrutid FAQ – häufige Fragen und Antworten",
      en: "Retatrutide FAQ – frequently asked questions",
    },
  },
  "/vergleich": {
    url: img("vergleich.jpg"),
    alt: {
      de: "Vergleich Retatrutid vs Semaglutid vs Tirzepatid",
      en: "Comparison Retatrutide vs Semaglutide vs Tirzepatide",
    },
  },
  "/reta-vs-ozempic": {
    url: img("reta-vs-ozempic.jpg"),
    alt: {
      de: "Reta vs Ozempic – Triple-Agonist gegen GLP-1-Mono",
      en: "Reta vs Ozempic – triple agonist versus GLP-1 mono",
    },
  },
  "/promis": {
    url: img("promis.jpg"),
    alt: {
      de: "GLP-1 und Promis – Ozempic-Stars und die nächste Generation",
      en: "GLP-1 and celebrities – Ozempic stars and the next generation",
    },
  },
  "/zulassung": {
    url: img("zulassung.jpg"),
    alt: {
      de: "Retatrutid Molekül – Zulassung FDA & EMA 2026",
      en: "Retatrutide molecule – FDA & EMA approval 2026",
    },
  },
  "/nebenwirkungen": {
    url: img("nebenwirkungen.jpg"),
    alt: {
      de: "Retatrutid Nebenwirkungen und Dosis-Eskalation",
      en: "Retatrutide side effects and dose escalation",
    },
  },
  "/thailand": {
    url: img("thailand.jpg"),
    alt: {
      de: "Bangkok Thailand – GLP-1-Therapie für Expats",
      en: "Bangkok Thailand – GLP-1 therapy for expats",
    },
  },
  "/ueber-uns": {
    url: img("home.jpg"),
    alt: {
      de: "Deutsch-thailändisches Team aus Ärzten, Wissenschaftlern und Chemikern",
      en: "German-Thai team of physicians, scientists and chemists",
    },
  },
  "/kontakt": {
    url: img("kontakt.jpg"),
    alt: {
      de: "Persönliche Beratung auf Deutsch – Retatrutid Thailand",
      en: "Personal consultation in German and English – Retatrutid Thailand",
    },
  },
};
